export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";